// Task 5.9: Dinamik Rol ve Yetki Yönetimi
// Kurallar: Kod içinde asla "user.role === 'satinalma'" yazma. "hasPermission" kullan.

export const PERMISSIONS = {
    // --- SAYFA ERİŞİMLERİ (Navigation) ---
    VIEW_PAGE_DASHBOARD: 'VIEW_PAGE_DASHBOARD',
    VIEW_PAGE_REQUESTS: 'VIEW_PAGE_REQUESTS',
    VIEW_PAGE_ORDERS: 'VIEW_PAGE_ORDERS',
    VIEW_PAGE_APPROVALS: 'VIEW_PAGE_APPROVALS',
    VIEW_PAGE_GRN: 'VIEW_PAGE_GRN',
    VIEW_PAGE_PRODUCTION: 'VIEW_PAGE_PRODUCTION',
    VIEW_PAGE_FINANCE: 'VIEW_PAGE_FINANCE',
    VIEW_PAGE_REPORTS: 'VIEW_PAGE_REPORTS',
    VIEW_PAGE_ADMIN: 'VIEW_PAGE_ADMIN',
    VIEW_PAGE_SUPPLIERS: 'VIEW_PAGE_SUPPLIERS',
    MANAGE_SUPPLIERS: 'MANAGE_SUPPLIERS',
    VIEW_PAGE_INVENTORY: 'VIEW_PAGE_INVENTORY',
    VIEW_PAGE_FINANCE: 'VIEW_PAGE_FINANCE',
    VIEW_RAPOR_LOGO_MUTABAKAT: 'VIEW_RAPOR_LOGO_MUTABAKAT',
    
    VIEW_PAGE_MUHASEBE_LOGO: 'VIEW_PAGE_MUHASEBE_LOGO',
    VIEW_PAGE_FATURA_GIRISI: 'VIEW_PAGE_FATURA_GIRISI',
    VIEW_PAGE_TRANSFER: 'VIEW_PAGE_TRANSFER',

    // --- DIŞ MÜŞTERİ SATIŞI (PR-A) ---
    VIEW_PAGE_SATIS: 'VIEW_PAGE_SATIS',     // Satış sayfaları görüntüleme
    MANAGE_SATIS: 'MANAGE_SATIS',           // Satış belgeleri (fatura/iade) CRUD + irsaliye onayla/iptal
    CREATE_SATIS_IRSALIYE: 'CREATE_SATIS_IRSALIYE', // İrsaliye OLUŞTUR (TASLAK) — depo dahil; onaylamaz
    MANAGE_TAHSILAT: 'MANAGE_TAHSILAT',     // Tahsilat kaydet/iptal

    // --- TALEP YÖNETİMİ ---
    VIEW_ALL_REQUESTS: 'VIEW_ALL_REQUESTS', // Tüm talepleri görme (yoksa sadece kendininkiler)
    CREATE_REQUEST: 'CREATE_REQUEST',       // Yeni talep oluşturma
    APPROVE_REQUEST: 'APPROVE_REQUEST',     // Talep onaylama
    REJECT_REQUEST: 'REJECT_REQUEST',       // Talep reddetme
    CONVERT_TO_ORDER: 'CONVERT_TO_ORDER',   // Talebi siparişe dönüştürme

    // --- SİPARİŞ YÖNETİMİ ---
    CREATE_ORDER: 'CREATE_ORDER',           // Yeni sipariş oluşturma
    VIEW_ALL_ORDERS: 'VIEW_ALL_ORDERS',
    APPROVE_ORDER_L1: 'APPROVE_ORDER_L1',   // 1. Seviye Onay (Md. Yrd / Satınalma Md)
    APPROVE_ORDER_L2: 'APPROVE_ORDER_L2',   // 2. Seviye Onay (Genel Müdür)

    // --- STOK & ÜRETİM ---
    MANAGE_GRN: 'MANAGE_GRN',               // Mal kabul yapabilme
    MANAGE_PRODUCTION: 'MANAGE_PRODUCTION', // Üretim/Kesim girebilme
    VIEW_STOCK: 'VIEW_STOCK',               // Stok görüntüleme
    MANAGE_INVENTORY_TRANSFER: 'MANAGE_INVENTORY_TRANSFER', // Transfer yapabilme

    // --- RAPORLAMA ---
    VIEW_COST_REPORTS: 'VIEW_COST_REPORTS',  // Maliyet raporları
    VIEW_SALES_REPORTS: 'VIEW_SALES_REPORTS', // Satış raporları
    VIEW_PERFORMANCE_REPORTS: 'VIEW_PERFORMANCE_REPORTS', // Performans raporları
    VIEW_ERP_USAGE_REPORT: 'VIEW_ERP_USAGE_REPORT',

    // --- REÇETE & MALİYET ---
    VIEW_PAGE_RECIPES: 'VIEW_PAGE_RECIPES',           // Reçete listesi görüntüleme
    MANAGE_RECIPES: 'MANAGE_RECIPES',                   // Reçete oluştur/düzenle/sil
    VIEW_RECIPE_COSTS: 'VIEW_RECIPE_COSTS',             // Maliyet hesaplama & analiz
    MANAGE_TRANSFER_PRICES: 'MANAGE_TRANSFER_PRICES',   // Transfer fiyatları yönetimi
    ACCESS_SECRET_RECIPES: 'ACCESS_SECRET_RECIPES',     // Gizli reçete içeriğini (malzeme) görme
    GRANT_SECRET_RECIPES: 'GRANT_SECRET_RECIPES',       // Gizli görme iznini ATAYABİLME (yalnız Hakan)

    // --- POS SATIŞ ---
    VIEW_POS_DATA: 'VIEW_POS_DATA',                // POS raporlarını görüntüleme
    MANAGE_POS_DATA: 'MANAGE_POS_DATA',            // POS raporu yükleme + stok düşümü işleme
    MANAGE_POS_MAPPINGS: 'MANAGE_POS_MAPPINGS',    // Ürün-reçete eşleştirme CRUD
    MANAGE_POS_EMAIL: 'MANAGE_POS_EMAIL',          // POS email otomatik ingest tetikleme (yönetim+admin)

    // --- ÖDEME PLANI ---
    CREATE_PAYMENT_PLAN: 'CREATE_PAYMENT_PLAN',     // Ödeme planı oluştur/gönder
    MANAGE_PAYMENT_PLAN: 'MANAGE_PAYMENT_PLAN',     // Kalem öde (muhasebe)
    VIEW_PAYMENT_PLAN: 'VIEW_PAYMENT_PLAN',         // Planları görüntüle

    // --- MENÜ MÜHENDİSLİĞİ ---
    VIEW_MENU_ENGINEERING: 'VIEW_MENU_ENGINEERING',
    MANAGE_MENU_ENGINEERING: 'MANAGE_MENU_ENGINEERING',

    // --- ADMIN ---
    MANAGE_USERS: 'MANAGE_USERS',
    MANAGE_SETTINGS: 'MANAGE_SETTINGS',

    // --- FİYAT BAND GÜVENLİK KATMANI ---
    MANAGE_PRICE_BAND: 'MANAGE_PRICE_BAND',     // Fiyat band config CRUD + uyarı listesi

    // --- FİNANSAL VERİ GİZLİLİĞİ ---
    VIEW_FINANCIAL_CIRO: 'VIEW_FINANCIAL_CIRO',           // POS ciro rakamları
    VIEW_FINANCIAL_BORC: 'VIEW_FINANCIAL_BORC',           // Borç, bakiye, ödeme detayları
    VIEW_FINANCIAL_FIYAT: 'VIEW_FINANCIAL_FIYAT',         // Tedarikçi alış fiyatları
    VIEW_FINANCIAL_MALIYET: 'VIEW_FINANCIAL_MALIYET',     // Food cost, reçete maliyeti
    VIEW_FINANCIAL_GIDER: 'VIEW_FINANCIAL_GIDER',         // Gider detayları, K/Z
    VIEW_FINANCIAL_URETIM: 'VIEW_FINANCIAL_URETIM',       // Üretim maliyeti (kg/TL)

    // --- İNSAN KAYNAKLARI ---
    MANAGE_HR: 'MANAGE_HR',
    VIEW_PAGE_HR: 'VIEW_PAGE_HR',

    // --- ANALİTİK (Faz 0+1) ---
    VIEW_EXECUTIVE_COCKPIT: 'VIEW_EXECUTIVE_COCKPIT',
    VIEW_ANALYTICS_PNL: 'VIEW_ANALYTICS_PNL',
    VIEW_ANALYTICS_SATINALMA: 'VIEW_ANALYTICS_SATINALMA',
    VIEW_ANALYTICS_SATIS: 'VIEW_ANALYTICS_SATIS',
    VIEW_ANALYTICS_TEDARIKCI: 'VIEW_ANALYTICS_TEDARIKCI',
    VIEW_ANALYTICS_STOK_URETIM: 'VIEW_ANALYTICS_STOK_URETIM',

    // --- KASA DOĞRULAMA (Faz 1) ---
    VIEW_KASA_KAPANIS: 'VIEW_KASA_KAPANIS',
    MANAGE_KASA_KAPANIS: 'MANAGE_KASA_KAPANIS',
    YENIDEN_AC_KASA_KAPANIS: 'YENIDEN_AC_KASA_KAPANIS',

    // --- KREDİ KARTI EKSTRE TAKİBİ ---
    MANAGE_CREDIT_CARDS: 'MANAGE_CREDIT_CARDS',   // Ekstre ödemesi (nakit hareketi) kaydet/iptal + özet/detay

    // --- YATIRIM FİZİBİLİTE (R8) ---
    VIEW_FEASIBILITY: 'VIEW_FEASIBILITY',
    MANAGE_FEASIBILITY: 'MANAGE_FEASIBILITY'
};

// Rol -> Yetki Eşleşmesi
export const ROLE_DEFINITIONS = {
    // Admin: Tüm yetkiler otomatik. Yeni permission eklendiğinde admin'e ayrıca eklemeye gerek yok.
    'admin': Object.values(PERMISSIONS),

    'yonetim': [
        // Pages - tum sayfalar
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_APPROVALS,
        PERMISSIONS.VIEW_PAGE_ADMIN,
        PERMISSIONS.VIEW_PAGE_REPORTS,
        PERMISSIONS.VIEW_PAGE_REQUESTS,
        PERMISSIONS.VIEW_PAGE_ORDERS,
        PERMISSIONS.VIEW_PAGE_GRN,
        PERMISSIONS.VIEW_PAGE_INVENTORY,
        PERMISSIONS.VIEW_PAGE_PRODUCTION,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_SUPPLIERS,
        PERMISSIONS.MANAGE_SUPPLIERS,
        PERMISSIONS.VIEW_ERP_USAGE_REPORT,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_MUHASEBE_LOGO,
        PERMISSIONS.VIEW_RAPOR_LOGO_MUTABAKAT,

        // Dış Müşteri Satışı (PR-A)
        PERMISSIONS.VIEW_PAGE_SATIS,
        PERMISSIONS.MANAGE_SATIS,
        PERMISSIONS.CREATE_SATIS_IRSALIYE,
        PERMISSIONS.MANAGE_TAHSILAT,

        // Actions
        PERMISSIONS.VIEW_ALL_REQUESTS,
        PERMISSIONS.CREATE_REQUEST,
        PERMISSIONS.APPROVE_REQUEST,
        PERMISSIONS.REJECT_REQUEST,
        PERMISSIONS.CONVERT_TO_ORDER,
        PERMISSIONS.CREATE_ORDER,
        PERMISSIONS.VIEW_ALL_ORDERS,
        PERMISSIONS.APPROVE_ORDER_L1,
        PERMISSIONS.APPROVE_ORDER_L2,
        PERMISSIONS.VIEW_COST_REPORTS,
        PERMISSIONS.VIEW_SALES_REPORTS,
        PERMISSIONS.VIEW_PERFORMANCE_REPORTS,
        PERMISSIONS.MANAGE_USERS,
        PERMISSIONS.MANAGE_SETTINGS,
        PERMISSIONS.MANAGE_PRICE_BAND,
        PERMISSIONS.MANAGE_GRN,
        PERMISSIONS.MANAGE_PRODUCTION,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_INVENTORY_TRANSFER,

        // Reçete & Maliyet
        PERMISSIONS.VIEW_PAGE_RECIPES,
        PERMISSIONS.MANAGE_RECIPES,
        PERMISSIONS.VIEW_RECIPE_COSTS,
        PERMISSIONS.MANAGE_TRANSFER_PRICES,
        // ACCESS_SECRET_RECIPES yönetim rolünde YOK (Hasan kararı 2026-06-12):
        // gizli reçete içeriği yalnız kişi-bazlı (kullanici_izinleri) atamayla görülür.

        // POS
        PERMISSIONS.VIEW_POS_DATA,
        PERMISSIONS.MANAGE_POS_DATA,
        PERMISSIONS.MANAGE_POS_MAPPINGS,
        PERMISSIONS.MANAGE_POS_EMAIL,

        // Ödeme Planı
        PERMISSIONS.CREATE_PAYMENT_PLAN,
        PERMISSIONS.MANAGE_PAYMENT_PLAN,
        PERMISSIONS.VIEW_PAYMENT_PLAN,

        // Menü Mühendisliği
        PERMISSIONS.VIEW_MENU_ENGINEERING,
        PERMISSIONS.MANAGE_MENU_ENGINEERING,

        // Finansal Veri Gizliliği
        PERMISSIONS.VIEW_FINANCIAL_CIRO,
        PERMISSIONS.VIEW_FINANCIAL_BORC,
        PERMISSIONS.VIEW_FINANCIAL_FIYAT,
        PERMISSIONS.VIEW_FINANCIAL_MALIYET,
        PERMISSIONS.VIEW_FINANCIAL_GIDER,
        PERMISSIONS.VIEW_FINANCIAL_URETIM,

        // İnsan Kaynakları
        PERMISSIONS.MANAGE_HR,
        PERMISSIONS.VIEW_PAGE_HR,

        // Analitik (Faz 0+1) — tüm cockpitler
        PERMISSIONS.VIEW_EXECUTIVE_COCKPIT,
        PERMISSIONS.VIEW_ANALYTICS_PNL,
        PERMISSIONS.VIEW_ANALYTICS_SATINALMA,
        PERMISSIONS.VIEW_ANALYTICS_SATIS,
        PERMISSIONS.VIEW_ANALYTICS_TEDARIKCI,
        PERMISSIONS.VIEW_ANALYTICS_STOK_URETIM,

        // Kasa Doğrulama (Faz 1) — tam yetki
        PERMISSIONS.VIEW_KASA_KAPANIS,
        PERMISSIONS.MANAGE_KASA_KAPANIS,
        PERMISSIONS.YENIDEN_AC_KASA_KAPANIS,

        // Yatırım Fizibilite (R8) — görüntüle + yönet
        PERMISSIONS.VIEW_FEASIBILITY,
        PERMISSIONS.MANAGE_FEASIBILITY,

        // Kredi Kartı Ekstre Takibi — ekstre ödemesi kaydet/iptal
        PERMISSIONS.MANAGE_CREDIT_CARDS
    ],
    'yonetici_ai': [
        // Pages - tum sayfalar
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_APPROVALS,
        PERMISSIONS.VIEW_PAGE_ADMIN,
        PERMISSIONS.VIEW_PAGE_REPORTS,
        PERMISSIONS.VIEW_PAGE_REQUESTS,
        PERMISSIONS.VIEW_PAGE_ORDERS,
        PERMISSIONS.VIEW_PAGE_GRN,
        PERMISSIONS.VIEW_PAGE_INVENTORY,
        PERMISSIONS.VIEW_PAGE_PRODUCTION,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_SUPPLIERS,
        PERMISSIONS.MANAGE_SUPPLIERS,
        PERMISSIONS.VIEW_ERP_USAGE_REPORT,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_MUHASEBE_LOGO,
        PERMISSIONS.VIEW_RAPOR_LOGO_MUTABAKAT,

        // Dış Müşteri Satışı (PR-A)
        PERMISSIONS.VIEW_PAGE_SATIS,
        PERMISSIONS.MANAGE_SATIS,
        PERMISSIONS.CREATE_SATIS_IRSALIYE,
        PERMISSIONS.MANAGE_TAHSILAT,

        // Actions
        PERMISSIONS.VIEW_ALL_REQUESTS,
        PERMISSIONS.CREATE_REQUEST,
        PERMISSIONS.APPROVE_REQUEST,
        PERMISSIONS.REJECT_REQUEST,
        PERMISSIONS.CONVERT_TO_ORDER,
        PERMISSIONS.CREATE_ORDER,
        PERMISSIONS.VIEW_ALL_ORDERS,
        PERMISSIONS.APPROVE_ORDER_L1,
        PERMISSIONS.APPROVE_ORDER_L2,
        PERMISSIONS.VIEW_COST_REPORTS,
        PERMISSIONS.VIEW_SALES_REPORTS,
        PERMISSIONS.VIEW_PERFORMANCE_REPORTS,
        //PERMISSIONS.MANAGE_USERS,
        PERMISSIONS.MANAGE_SETTINGS,
        PERMISSIONS.MANAGE_PRICE_BAND,
        PERMISSIONS.MANAGE_GRN,
        PERMISSIONS.MANAGE_PRODUCTION,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_INVENTORY_TRANSFER,

        // Reçete & Maliyet
        PERMISSIONS.VIEW_PAGE_RECIPES,
        PERMISSIONS.MANAGE_RECIPES,
        PERMISSIONS.VIEW_RECIPE_COSTS,
        PERMISSIONS.MANAGE_TRANSFER_PRICES,
        // ACCESS_SECRET_RECIPES yönetim rolünde YOK (Hasan kararı 2026-06-12):
        // gizli reçete içeriği yalnız kişi-bazlı (kullanici_izinleri) atamayla görülür.

        // POS
        PERMISSIONS.VIEW_POS_DATA,
        PERMISSIONS.MANAGE_POS_DATA,
        PERMISSIONS.MANAGE_POS_MAPPINGS,
        PERMISSIONS.MANAGE_POS_EMAIL,

        // Ödeme Planı
        PERMISSIONS.CREATE_PAYMENT_PLAN,
        PERMISSIONS.MANAGE_PAYMENT_PLAN,
        PERMISSIONS.VIEW_PAYMENT_PLAN,

        // Menü Mühendisliği
        PERMISSIONS.VIEW_MENU_ENGINEERING,
        PERMISSIONS.MANAGE_MENU_ENGINEERING,

        // Finansal Veri Gizliliği
        PERMISSIONS.VIEW_FINANCIAL_CIRO,
        PERMISSIONS.VIEW_FINANCIAL_BORC,
        PERMISSIONS.VIEW_FINANCIAL_FIYAT,
        PERMISSIONS.VIEW_FINANCIAL_MALIYET,
        PERMISSIONS.VIEW_FINANCIAL_GIDER,
        PERMISSIONS.VIEW_FINANCIAL_URETIM,

        // İnsan Kaynakları
        //PERMISSIONS.MANAGE_HR,
        //PERMISSIONS.VIEW_PAGE_HR,

        // Analitik (Faz 0+1) — tüm cockpitler
        PERMISSIONS.VIEW_EXECUTIVE_COCKPIT,
        PERMISSIONS.VIEW_ANALYTICS_PNL,
        PERMISSIONS.VIEW_ANALYTICS_SATINALMA,
        PERMISSIONS.VIEW_ANALYTICS_SATIS,
        PERMISSIONS.VIEW_ANALYTICS_TEDARIKCI,
        PERMISSIONS.VIEW_ANALYTICS_STOK_URETIM,

        // Kasa Doğrulama (Faz 1) — tam yetki
        PERMISSIONS.VIEW_KASA_KAPANIS,
        PERMISSIONS.MANAGE_KASA_KAPANIS,
        PERMISSIONS.YENIDEN_AC_KASA_KAPANIS,

        // Yatırım Fizibilite (R8) — görüntüle + yönet
        PERMISSIONS.VIEW_FEASIBILITY,
        PERMISSIONS.MANAGE_FEASIBILITY,

        // Kredi Kartı Ekstre Takibi — ekstre ödemesi kaydet/iptal
        //PERMISSIONS.MANAGE_CREDIT_CARDS
    ],
    'satinalma': [
        // Pages
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_REQUESTS,
        PERMISSIONS.VIEW_PAGE_ORDERS,
        PERMISSIONS.VIEW_PAGE_APPROVALS,
        PERMISSIONS.VIEW_PAGE_SUPPLIERS,
        PERMISSIONS.MANAGE_SUPPLIERS,
        PERMISSIONS.VIEW_PAGE_REPORTS,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_GRN,
        PERMISSIONS.VIEW_PAGE_INVENTORY,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_MUHASEBE_LOGO,

        // Actions — Satınalma siparişi takip eder, mal kabul yapabilir, stok izleyebilir
        PERMISSIONS.VIEW_ALL_REQUESTS,
        PERMISSIONS.CREATE_REQUEST,
        PERMISSIONS.APPROVE_REQUEST,
        PERMISSIONS.REJECT_REQUEST,
        PERMISSIONS.CONVERT_TO_ORDER,
        PERMISSIONS.CREATE_ORDER,
        PERMISSIONS.VIEW_ALL_ORDERS,
        PERMISSIONS.APPROVE_ORDER_L1,
        PERMISSIONS.VIEW_COST_REPORTS,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_GRN,

        // Reçete (görüntüleme + düzenleme)
        PERMISSIONS.VIEW_PAGE_RECIPES,
        PERMISSIONS.MANAGE_RECIPES,
        PERMISSIONS.VIEW_RECIPE_COSTS,

        // Finansal Veri Gizliliği
        PERMISSIONS.VIEW_FINANCIAL_FIYAT,
        PERMISSIONS.VIEW_FINANCIAL_MALIYET,
        PERMISSIONS.VIEW_FINANCIAL_URETIM,

        // Analitik (Faz 0+1)
        PERMISSIONS.VIEW_ANALYTICS_SATINALMA,
        PERMISSIONS.VIEW_ANALYTICS_TEDARIKCI,
        PERMISSIONS.VIEW_ANALYTICS_STOK_URETIM,

        // Menü Mühendisliği — RBAC geçişi öncesi rol-listesinde vardı (analiz
        // çalıştırma + malzeme simülasyonu); izin anahtarına taşındı (M.5)
        PERMISSIONS.VIEW_MENU_ENGINEERING,
        PERMISSIONS.MANAGE_MENU_ENGINEERING
    ],
    'uretim': [
        // Pages
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_PRODUCTION,
        PERMISSIONS.VIEW_PAGE_GRN,
        PERMISSIONS.VIEW_PAGE_INVENTORY,

        // Actions — Üretim ekibi mal kabul + kesim + parçalama + stok yapar
        PERMISSIONS.MANAGE_GRN,
        PERMISSIONS.MANAGE_PRODUCTION,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_INVENTORY_TRANSFER,

        // Reçete & Maliyet
        PERMISSIONS.VIEW_PAGE_RECIPES,
        PERMISSIONS.MANAGE_RECIPES,
        PERMISSIONS.VIEW_RECIPE_COSTS,

        // Finansal Veri Gizliliği
        PERMISSIONS.VIEW_FINANCIAL_URETIM,

        // Analitik (Faz 0+1)
        PERMISSIONS.VIEW_ANALYTICS_STOK_URETIM
    ],
    'depo': [
        // Pages
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_GRN,
        PERMISSIONS.VIEW_PAGE_INVENTORY,
        // Dış Müşteri Satışı (PE1) — depo satış sayfalarını görür + irsaliye OLUŞTURUR
        PERMISSIONS.VIEW_PAGE_SATIS,

        // Actions
        PERMISSIONS.MANAGE_GRN,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_INVENTORY_TRANSFER,
        // İrsaliye oluşturur (TASLAK) — onaylama/iptal/fatura MANAGE_SATIS'te kalır (yok)
        PERMISSIONS.CREATE_SATIS_IRSALIYE
    ],
    'sube': [
        // Pages — Şube müdürü kendi şubesini yönetir
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_REQUESTS,
        PERMISSIONS.VIEW_PAGE_INVENTORY,
        PERMISSIONS.VIEW_PAGE_REPORTS,

        // Actions
        PERMISSIONS.CREATE_REQUEST,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_INVENTORY_TRANSFER,
        PERMISSIONS.VIEW_SALES_REPORTS,

        // POS (rapor yükleme + işleme, mapping değiştirme yok)
        PERMISSIONS.VIEW_POS_DATA,
        PERMISSIONS.MANAGE_POS_DATA,

        // Menü Mühendisliği (okuma — hangi ürün satılıyor, fiyat takibi)
        PERMISSIONS.VIEW_MENU_ENGINEERING
    ],
    'muhasebe': [
        // Pages — Muhasebe mali verileri, faturaları ve stoku izler
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_REPORTS,
        PERMISSIONS.VIEW_PAGE_SUPPLIERS,
        PERMISSIONS.VIEW_PAGE_ORDERS,
        PERMISSIONS.VIEW_PAGE_GRN,
        PERMISSIONS.VIEW_PAGE_INVENTORY,
        PERMISSIONS.VIEW_PAGE_PRODUCTION,        // Üretim sayfası görünürlük
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_MUHASEBE_LOGO,
        PERMISSIONS.VIEW_RAPOR_LOGO_MUTABAKAT,
        
        // Dış Müşteri Satışı (PR-A)
        PERMISSIONS.VIEW_PAGE_SATIS,
        PERMISSIONS.MANAGE_SATIS,
        PERMISSIONS.CREATE_SATIS_IRSALIYE,
        PERMISSIONS.MANAGE_TAHSILAT,

        // Actions — Maliyet kontrol, rapor, stok takibi
        PERMISSIONS.VIEW_COST_REPORTS,
        PERMISSIONS.VIEW_SALES_REPORTS,
        PERMISSIONS.VIEW_PERFORMANCE_REPORTS,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_PRODUCTION,            // Üretim oluşturma/tamamlama
        PERMISSIONS.MANAGE_INVENTORY_TRANSFER,    // Transfer sayfası

        // Reçete (görüntüleme)
        PERMISSIONS.VIEW_PAGE_RECIPES,
        PERMISSIONS.VIEW_RECIPE_COSTS,

        // POS (sadece görüntüleme)
        PERMISSIONS.VIEW_POS_DATA,

        // Ödeme Planı (ödeme yapma + görüntüleme)
        PERMISSIONS.MANAGE_PAYMENT_PLAN,
        PERMISSIONS.VIEW_PAYMENT_PLAN,

        // Menü Mühendisliği (okuma)
        PERMISSIONS.VIEW_MENU_ENGINEERING,

        // Finansal Veri Gizliliği
        PERMISSIONS.VIEW_FINANCIAL_CIRO,
        PERMISSIONS.VIEW_FINANCIAL_BORC,
        PERMISSIONS.VIEW_FINANCIAL_FIYAT,
        PERMISSIONS.VIEW_FINANCIAL_MALIYET,
        PERMISSIONS.VIEW_FINANCIAL_GIDER,
        PERMISSIONS.VIEW_FINANCIAL_URETIM,

        // Analitik (Faz 0+1)
        PERMISSIONS.VIEW_ANALYTICS_PNL,
        PERMISSIONS.VIEW_ANALYTICS_SATINALMA,
        PERMISSIONS.VIEW_ANALYTICS_SATIS,
        PERMISSIONS.VIEW_ANALYTICS_TEDARIKCI,

        // Kasa Doğrulama (Faz 1) — yeniden açma hariç tam yetki
        PERMISSIONS.VIEW_KASA_KAPANIS,
        PERMISSIONS.MANAGE_KASA_KAPANIS,

        // Fiyat Band Güvenlik Katmanı — band config + uyarı listesi yönetimi
        PERMISSIONS.MANAGE_PRICE_BAND,

        // Kredi Kartı Ekstre Takibi — ekstre ödemesi kaydet/iptal
        PERMISSIONS.MANAGE_CREDIT_CARDS
    ],
    'ik': [
        // İK personeli — sadece İK modülü + dashboard
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_HR,
        PERMISSIONS.MANAGE_HR,
    ],
    'operasyon': [
        // Pages — Operasyon tüm sahayı takip eder
        PERMISSIONS.VIEW_PAGE_DASHBOARD,
        PERMISSIONS.VIEW_PAGE_REPORTS,
        PERMISSIONS.VIEW_PAGE_PRODUCTION,
        PERMISSIONS.VIEW_PAGE_GRN,
        PERMISSIONS.VIEW_PAGE_INVENTORY,
        PERMISSIONS.VIEW_PAGE_SUPPLIERS,
        PERMISSIONS.VIEW_PAGE_FINANCE,
        PERMISSIONS.VIEW_PAGE_MUHASEBE_LOGO,
        
        // Actions — Üretim + stok + maliyet takibi
        PERMISSIONS.MANAGE_PRODUCTION,
        PERMISSIONS.VIEW_STOCK,
        PERMISSIONS.MANAGE_INVENTORY_TRANSFER,
        PERMISSIONS.VIEW_COST_REPORTS,
        PERMISSIONS.VIEW_SALES_REPORTS,
        PERMISSIONS.VIEW_PERFORMANCE_REPORTS,

        // Reçete & Maliyet (görüntüleme)
        PERMISSIONS.VIEW_PAGE_RECIPES,
        PERMISSIONS.VIEW_RECIPE_COSTS,

        // POS (tam yetki)
        PERMISSIONS.VIEW_POS_DATA,
        PERMISSIONS.MANAGE_POS_DATA,
        PERMISSIONS.MANAGE_POS_MAPPINGS,

        // Ödeme Planı (görüntüleme — CREATE ise custom permission ile)
        PERMISSIONS.VIEW_PAYMENT_PLAN,

        // Menü Mühendisliği (okuma)
        PERMISSIONS.VIEW_MENU_ENGINEERING,

        // Finansal Veri Gizliliği
        PERMISSIONS.VIEW_FINANCIAL_CIRO,
        PERMISSIONS.VIEW_FINANCIAL_MALIYET,
        PERMISSIONS.VIEW_FINANCIAL_URETIM
    ]
};

// Yetki Kontrolü Helper — PR2: DB-driven RBAC
// effectivePermissions: backend /api/auth/me'den gelen efektif izin listesi
//   (rol izinleri DB ∪ custom izinler). Birincil kaynak budur.
// ROLE_DEFINITIONS: yalnızca FALLBACK — effective henüz yüklenmediyse (login/mount
//   anı) veya /me erişilemezse (Anayasa Madde 1: API-erişilemez fallback'i serbest).
//   effective ⊇ ROLE_DEFINITIONS (backend parity testi garanti eder) → regresyon yok.
export const hasPermission = (role, permission, effectivePermissions = []) => {
    if (effectivePermissions && effectivePermissions.length > 0) {
        return effectivePermissions.includes(permission);
    }
    const perms = ROLE_DEFINITIONS[role] || [];
    return perms.includes(permission);
};
